// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f9f996ef","453":"ed3810f9","796":"2f02504a"}[chunkId] + ".chunk.js";
};